import merge from 'deepmerge';

import { Translations } from '../types';

import common from './common';
import customer from './customer';
import fr from './fr/mobile.json';
import en from './en/mobile.json';

const mobile = {
  fr: fr.mobile,
  en: en.mobile,
};

export default merge.all<Translations>([common, customer, mobile]);
